import React, { useEffect } from 'react';
import { PageLayoutsContainer } from '@wajeez-web/components/layouts';
import { Card, TextInput, Button } from '@wajeez-web/components/ui';
import { TbUserSearch, TbDevices2 } from 'react-icons/tb';
import { useNavigate, useParams } from 'react-router-dom';
import { ImStatsBars } from 'react-icons/im';
import { MdDevices, MdShareLocation } from 'react-icons/md';
import { getMonthName } from '@wajeez-web/core/utils';
import UserSubscriptionHistoryTimeLine from '../components/UserSubscriptionHistoryTimeLine';
import UserDetailedRetuntionChart from '../components/UserDetailedRetuntionChart';
import {
  useCustomerSelector,
  useCustomerDispatch,
  CustomerCareActions,
  UserAnalyticsActions,
} from '@wajeez-web/stores/customers';
import UserSessionsModal from '../components/UserSessionsModal';
import UserConsumedContentModal from '../components/UserConsumedContentModal';
import UserDevicesModal from '../components/UserDevicesModal';
import { SearchIcon } from '@heroicons/react/solid';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
const CustomerAnalyticsPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const dispatch = useCustomerDispatch();
  const onSearch = (value: string) => {
    navigate(`/wajeez-customers/${value}/analytics`);
  };
  const { t } = useTranslation();
  const user = useCustomerSelector((state) => state.customerCare.details);
  const {
    userDailySessions,
    userConsumedContent,
    userDevices,
    userMonthlySessions,
  } = useCustomerSelector((state) => state.usersAnalytics);
  const { userPlans } = useCustomerSelector((state) => state.customerCare);
  // define states for userSubscriptionHistoryModal
  const [
    isUserSubscriptionHistoryModalOpen,
    setisUserSubscriptionHistoryModalOpen,
  ] = React.useState(false);
  // define states for userSessionModal
  const [isUserSessionModalOpen, setisUserSessionModalOpen] =
    React.useState(false);
  // define states for userDeviceModal
  const [isUserDeviceModalOpen, setisUserDeviceModalOpen] =
    React.useState(false);
  // define states for userConsumedContentModal
  const [isUserConsumedContentModalOpen, setisUserConsumedContentModalOpen] =
    React.useState(false);
  const [searchIdvalue, setSearchIdValue] = React.useState('');

  const showUserSessionModal = () => {
    setisUserSessionModalOpen(true);
  };
  const showUserDeviceModal = () => {
    setisUserDeviceModalOpen(true);
  };

  const showUserConsumedContentModal = () => {
    setisUserConsumedContentModalOpen(true);
  };

  useEffect(() => {
    if (id) {
      dispatch(CustomerCareActions.getUserByIdAsync(id));
      dispatch(UserAnalyticsActions.getUserDailySessionsAsync(id));
      dispatch(UserAnalyticsActions.getUserMonthlySessionsAsync(id));
      dispatch(UserAnalyticsActions.getUserConsumedContentAsync(id));
      dispatch(UserAnalyticsActions.getUserDevicesAsync(id));
      dispatch(UserAnalyticsActions.getUserSubscriptionHistoryAsync(id));
      dispatch(CustomerCareActions.getUserPlansAsync(id));
    }
  }, [id]);

  const getTableData = () => {
    return [
      {
        values: [
          {
            title: t('tables.columnTitles.User ID'),
            value: id,
          },
          {
            title: t('tables.columnTitles.Email'),
            value: user?.email,
          },
          {
            title: t('tables.columnTitles.Created Date'),
            value: moment(user?.createdDate).locale('en').format('DD-MM-YYYY'),
          },
          {
            title: t('tables.columnTitles.Last Login'),
            value: user?.lastLoginDate
              ? moment(user?.lastLoginDate).locale('en').format('DD-MM-YYYY')
              : t('tables.columnValues.Unknown'),
          },
        ],
        icon: TbUserSearch,
      },
      {
        values: [
          {
            title: t('tables.columnTitles.Total Sessions'),
            value:
              userMonthlySessions?.reduce(
                (acc: number, session) => acc + (session.numberOfSessions || 0),
                0
              ) +
              userDailySessions?.reduce(
                (acc: number, session) => acc + (session.numberOfSessions || 0),
                0
              ),
          },
          {
            title: t('tables.columnTitles.Total Session durations'),
            value: (
              <div className="text-[#727783] text-[16px] font-normal flex space-s-2 ">
                <div className="flex space-s-1 ">
                  <div>
                    {(
                      Math.round(
                        userMonthlySessions?.reduce(
                          (acc: number, session) =>
                            acc + (session.totalDurationInMinutes || 0),
                          0
                        )
                      ) / 60
                    ).toFixed(0)}
                  </div>

                  <div>ساعة</div>
                </div>
                <div> - </div>
                <div>
                  {Math.round(
                    userMonthlySessions?.reduce(
                      (acc: number, session) =>
                        acc + (session.totalDurationInMinutes || 0),
                      0
                    )
                  ).toFixed(0)}{' '}
                  دقيقة{' '}
                </div>
              </div>
            ),
          },
          {
            title: t('tables.columnTitles.No. Month used'),
            value: (
              <div className="text-[#727783] text-[16px] font-normal">
                {userMonthlySessions?.length > 3
                  ? userMonthlySessions
                      ?.slice(0, 3)
                      .map((session, index: number) => {
                        return (
                          <span key={index}>
                            {getMonthName(session.month)} {session.year}
                            {index < 2 ? ', ' : '...'}
                          </span>
                        );
                      })
                  : userMonthlySessions.map((session, index: number) => {
                      return (
                        <span key={index}>
                          {getMonthName(session.month)} {session.year}
                          {index < userMonthlySessions.length - 1 ? ', ' : ''}
                        </span>
                      );
                    })}
                <button
                  className="text-[#2a76df] text-[16px] font-normal"
                  onClick={showUserSessionModal}
                >
                  المزيد
                </button>
              </div>
            ),
          },
          {
            title: t('tables.columnTitles.Content Consumed'),
            value: (
              <div className="text-[#727783] text-[16px] font-normal">
                {userConsumedContent?.length > 3
                  ? userConsumedContent
                      ?.slice(0, 3)
                      .map((content, index: number) => {
                        return (
                          <span key={index}>
                            {content.title}
                            {index < 2 ? ', ' : '...'}
                          </span>
                        );
                      })
                  : userConsumedContent?.map((content, index: number) => {
                      return (
                        <span key={index}>
                          {content.title}
                          {index < userConsumedContent?.length - 1 ? ', ' : ''}
                        </span>
                      );
                    })}
                <button
                  className="text-[#2a76df] text-[16px] font-normal"
                  onClick={showUserConsumedContentModal}
                >
                  المزيد
                </button>
              </div>
            ),
          },
        ],
        icon: ImStatsBars,
      },
      {
        values: [
          {
            title: t('tables.columnTitles.Language'),
            value: t('tables.columnValues.Unknown'),
          },
          {
            title: t('tables.columnTitles.Country'),
            value: t('tables.columnValues.Unknown'),
          },
          {
            title: t('tables.columnTitles.Region'),
            value: t('tables.columnValues.Unknown'),
          },
        ],
        icon: MdShareLocation,
      },
      {
        values: [
          {
            title: t('tables.columnTitles.No. Devices'),
            value: (
              <div className="">
                <div className="text-[#727783] text-[16px] font-semibold">
                  ({userDevices?.length}){' '}
                </div>
                <div className="text-[#727783] text-[16px] font-normal">
                  {/* loop through user devices and get the model name and display it , if it's more than three slice  */}
                  {userDevices?.length > 3
                    ? userDevices?.slice(0, 3).map((device, index: number) => {
                        return (
                          <span key={index}>
                            {device.modelName}
                            {index < 2 ? ', ' : '...'}
                          </span>
                        );
                      })
                    : userDevices?.map((device, index: number) => {
                        return (
                          <span key={index}>
                            {device.modelName}
                            {index < userDevices?.length - 1 ? ', ' : ''}
                          </span>
                        );
                      })}
                </div>
                {/* a button and modal will show more details about the user devices */}
                <button
                  className="text-[#2a76df] text-[16px] font-normal"
                  onClick={showUserDeviceModal}
                >
                  المزيد
                </button>
              </div>
            ),
          },
          {
            title: t('tables.columnTitles.Subscription History'),
            value: (
              <div className="text-[#727783] text-[16px] font-normal">
                {userPlans?.[0]?.planName}
                <br />
                <button
                  className="text-[#2a76df] text-[16px] font-normal"
                  onClick={() => setisUserSubscriptionHistoryModalOpen(true)}
                >
                  المزيد
                </button>
              </div>
            ),
          },
        ],
        icon: MdDevices,
      },
    ];
  };

  return (
    <>
      <UserSessionsModal
        isOpen={isUserSessionModalOpen}
        onClose={() => setisUserSessionModalOpen(false)}
      />
      <UserConsumedContentModal
        isOpen={isUserConsumedContentModalOpen}
        onClose={() => setisUserConsumedContentModalOpen(false)}
      />
      <UserDevicesModal
        isOpen={isUserDeviceModalOpen}
        onClose={() => setisUserDeviceModalOpen(false)}
      />
      <UserSubscriptionHistoryTimeLine
        isOpen={isUserSubscriptionHistoryModalOpen}
        onClose={() => setisUserSubscriptionHistoryModalOpen(false)}
      />
      <PageLayoutsContainer
        title={'User Analytics'}
        bottomSidecomponent={
          <div className="flex space-s-2 w-full">
            <div className="w-full">
              <TextInput
                onClick={(e) => {
                  if (e.keyCode === 13) {
                    onSearch(searchIdvalue);
                  }
                }}
                shape="circle"
                value={searchIdvalue}
                onChange={(name, value) => setSearchIdValue(value)}
                name="searchInput"
                placeholder="Search User Using Id"
                prefix={<SearchIcon className="w-4 me-2" />}
              />
            </div>
            <Button
              disabled={searchIdvalue.length ? false : true}
              shape="circle"
              title={'Search'}
              onClick={() => onSearch(searchIdvalue)}
            />
          </div>
        }
      >
        <div>
          <div className="  scrollbar-track-white hover:scrollbar-thumb-gray-100  scrollbar-thin flex overflow-x-auto pb-10 xs:hide-scroll-bar  xs:scrollbar-none ">
            {' '}
            <div className="flex flex-nowrap flex-row w-full min-w-[1000px] ">
              {' '}
              <Card>
                <div className="divide-y  ">
                  {getTableData().map((row, index: number) => (
                    <div
                      key={`row-${index}`}
                      className="grid grid-cols-8 space-s-4 align-top  py-2 gap-4 min-h-[80px]"
                    >
                      {row.values.map((item, i) => (
                        <div
                          key={item.title}
                          className="col-span-2 flex space-s-4 items-center"
                        >
                          {i === 0 && (
                            <div className="">
                              <row.icon className="h-8 w-8 "></row.icon>
                            </div>
                          )}
                          <div className="space-y-2">
                            {' '}
                            <div className="text-[#727783] text-[18px] font-semibold">
                              {item.title}
                            </div>
                            <div className="text-[#727783] text-[16px] font-normal">
                              {item.value}
                            </div>
                          </div>
                        </div>
                      ))}{' '}
                    </div>
                  ))}
                </div>
              </Card>
            </div>
          </div>
          <div className="grid grid-cols-3">
            {user?.createdDate && (
              <UserDetailedRetuntionChart
                userId={id || ''}
                createdDate={user?.createdDate || ''}
              />
            )}
          </div>
        </div>
      </PageLayoutsContainer>
    </>
  );
};

export default CustomerAnalyticsPage;
